<app-header></app-header>
<div class="row w-100 h-100 mx-0 auth-page">
  <div class="col-md-4 col-xl-4 mx-auto quote">
    <login-quote></login-quote>
  </div>
  <div class="col-md-4 col-xl-4 mx-auto container">
    <div class="card p-3 h-100">
      <div class="m-auto auth-form-wrapper">
        <h4 class="login-title pb-4">{{ 'AUTH.JOIN' | translate }}</h4>
        <form class="forms-sample" [formGroup]="registerForm" [markRequired]="registerForm">
          <div class="form-group">
            <label for="exampleInputFirstName1">{{ 'AUTH.FIRST_NAME' | translate }}</label>
            <extended-input [inputControl]="registerForm.get('firstName')">
              <input type="text"
                  class="form-control"
                  id="exampleInputFirstName1"
                  autocomplete="First Name"
                  formControlName="firstName"
                  placeholder="{{ 'AUTH.PLACEHOLDER_PRE' | translate }} {{ 'AUTH.FIRST_NAME' | translate }}">
            </extended-input>
          </div>
          <div class="form-group">
            <label for="exampleInputLastName1">{{ 'AUTH.LAST_NAME' | translate }}</label>
            <extended-input [inputControl]="registerForm.get('lastName')">
            <input type="text"
                  class="form-control"
                  id="exampleInputLastName1"
                  autocomplete="Last Name"
                  formControlName="lastName"
                  placeholder="{{ 'AUTH.PLACEHOLDER_PRE' | translate }} {{ 'AUTH.LAST_NAME' | translate }}">
            </extended-input>
          </div>
          <div class="form-group">
            <label for="exampleInputEmail1">{{ 'AUTH.EMAIL' | translate }}</label>
            <extended-input [inputControl]="registerForm.get('email')">
            <input type="email"
                  class="form-control"
                  id="exampleInputEmail1"
                  formControlName="email"
                  placeholder="{{ 'AUTH.PLACEHOLDER_PRE' | translate }} {{ 'AUTH.EMAIL' | translate }}">
            </extended-input>
          </div>
          <div class="form-group">
            <label for="exampleInputPassword1">{{ 'AUTH.PASSWORD' | translate }}</label>
            <extended-input [inputControl]="registerForm.get('password')">
              <input type="password"
                  class="form-control"
                  id="exampleInputPassword1"
                  autocomplete="current-password"
                  formControlName="password"
                  placeholder="{{ 'AUTH.PLACEHOLDER_PRE' | translate }} {{ 'AUTH.PASSWORD' | translate }}">
            </extended-input>
          </div>

          <div class="mt-3">
            <button type="submit"
              class="btn btn-primary ml-2 mb-2 mb-md-0 w-100 submit-btn"
              [disabled]="!registerForm.valid"
              (click)="register()">
              {{ 'AUTH.SIGN_UP' | translate }}
            </button>
          </div>

          <div class="mt-3 social-login">
            <div class="separator">
              <hr/>
              <span class="register-with-title">
                {{ 'AUTH.REGISTER_WITH' | translate }}
              </span>
            </div>
            <div class="col-sm-12 my-auto social-buttons">
              <!--change to google logo-->
              <img src="assets/images/google-logo.png"
                    alt="Google"
                    class="auth-button google-sign-in"
                    auth="sign-in-with-google"
                    (click)="signInWithGoogle()">
              <!--change to facebook logo-->
              <img src="assets/images/facebook-logo.png"
                    alt="Facebook"
                    class="auth-button facebook-sign-in"
                    auth="sign-in-with-facebook"
                    (click)="signInWithFacebook()">
            </div>
          </div>
          <div class="col-12 d-flex justify-content-center">
            <a routerLink="/login" class="d-block mt-3 text-muted">{{ 'AUTH.ALREADY_USER' | translate }}</a>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
